import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetProfilesQuery } from 'services/backend';
import { RootState } from 'store/index';

export const useSelectedProfile = () => {
  const selectedProfileId = useSelector((state: RootState) => state.profile.selectedProfileId);

  const { selectedProfile, isLoading, isFetching } = useGetProfilesQuery(undefined, {
    selectFromResult: ({ data, isLoading: isQueryLoading, isFetching: isQueryFetching }) => ({
      selectedProfile: data?.find((profile) => profile.id === selectedProfileId) ?? null,
      isLoading: isQueryLoading,
      isFetching: isQueryFetching,
    }),
  });

  const isRestrictedProfile = useMemo(() => {
    if (!selectedProfile) return false;

    const ageRating = parseInt(selectedProfile?.ageRating ?? '', 10);

    return isNaN(ageRating) || ageRating <= 14 || !!selectedProfile.isKid;
  }, [selectedProfile]);

  return { selectedProfile, isLoading, isFetching, isRestrictedProfile };
};
